import { animalPieceTypes } from "../../../const";
import {
  ISideEffectHandler,
  SideEffectHandlerParams,
} from "./SideEffectHandler";

export class PoisonHandler implements ISideEffectHandler {
  handleSideEffect(params: SideEffectHandlerParams): void {
    if (params.sideEffects.length === 0) return;

    if (params.sideEffects.length > 1)
      throw new Error("Multiple poisons in a single move is invalid");

    var poison = params.sideEffects[0];

    if (poison.piecesToEffect.length === 0)
      throw new Error("No piece to poison");

    if (poison.piecesToEffect.length > 1)
      throw new Error("Only one piece can be poisoned per move");

    if (animalPieceTypes.includes(params.inflictingPiece.type)) {
      const removeOnTurn = params.currentTurnNumber + poison.effect.activeTurns!;
      poison.piecesToEffect[0].poisonedStatus = {
        isPoisoned: true,
        removeOnTurn: removeOnTurn,
      };
    }
  }
}
